<script>
import {defineComponent} from 'vue'
import {ElNotification} from "element-plus";
import {API_BASE, APPLICATION_TYPE_LABELS, DOWNLOADABLE_APPLICATION_TYPES} from "./constants";

const FILE_URL = process.env.VUE_APP_BASE_API_URL + "api/v2/info/file/";
const QUARTERS = ["1", "2", "3", "4"];

export default defineComponent({
  name: "OpennessOrganizationReports",
  data() {
    return {
      loading: false,
      organization: null,
      year: null,
      availableYears: [],
      rows: [],
      quarters: QUARTERS,
    }
  },
  methods: {
    applicationTypeLabel(type) {
      return APPLICATION_TYPE_LABELS[type] || `Turi ${type}`;
    },
    cellHref(cell, applicationType) {
      if (!cell || !cell.exists) return null;
      if (cell.file_id) return FILE_URL + cell.file_id;
      if (DOWNLOADABLE_APPLICATION_TYPES.includes(applicationType)) {
        return `${process.env.VUE_APP_BASE_API_URL}${API_BASE}/reports/${cell.report_id}/download`;
      }
      return null;
    },
    getOrganization() {
      this.$http.get(`${API_BASE}/${this.$route.params.id}`).then(({data}) => {
        this.organization = data;
      }).catch(() => {
        this.organization = null;
      })
    },
    getMatrix(year) {
      this.loading = true;
      this.$http.get(`${API_BASE}/${this.$route.params.id}/reports/matrix`, {
        params: year ? {year} : {}
      }).then(({data}) => {
        this.year = data.year;
        this.availableYears = data.available_years || [];
        this.rows = data.rows || [];
      }).catch(({response}) => {
        ElNotification.error({message: response?.data?.message || "Hisobotlarni yuklashda xatolik sodir bo'ldi."})
      }).finally(() => {
        this.loading = false
      })
    },
    onYearChange(year) {
      this.getMatrix(year);
    },
  },
  mounted() {
    this.getOrganization()
    this.getMatrix()
  }
})
</script>

<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <div>
        <el-button @click="$router.go(-1)">Orqaga</el-button>
        <span v-if="organization" class="org-title">{{ organization.title }} — hisobotlar</span>
      </div>
      <el-select v-model="year" placeholder="Yil" style="width: 120px" @change="onYearChange">
        <el-option v-for="y in availableYears" :key="y" :label="y" :value="y"/>
      </el-select>
    </div>
    <el-table :data="rows"
              class="table"
              border
              height="calc(100vh - 245px)">
      <el-table-column label="Hisobot turi" min-width="180">
        <template #default="scope">
          {{ applicationTypeLabel(scope.row.application_type) }}
        </template>
      </el-table-column>
      <el-table-column v-for="q in quarters" :key="q" :label="`${q}-chorak`" align="center" min-width="140">
        <template #default="scope">
          <a v-if="cellHref(scope.row.quarters[q], scope.row.application_type)"
             :href="cellHref(scope.row.quarters[q], scope.row.application_type)"
             target="_blank">
            Yuklab olish
          </a>
          <span v-else-if="scope.row.quarters[q] && scope.row.quarters[q].exists" class="not-downloadable">
            {{ scope.row.quarters[q].status }}
          </span>
          <span v-else class="not-available">—</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 10px;
  align-items: center;
}

.org-title {
  margin-left: 12px;
  font-family: "Montserrat-Bold", sans-serif;
}

.not-available,
.not-downloadable {
  color: var(--el-text-color-secondary);
}
</style>
